var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "faq-group" },
    [
      _vm._t("title", [
        _c("h2", { staticClass: "faq-group--title" }, [
          _vm._v(_vm._s(_vm.title))
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.items, function(item, idx) {
        return _c(
          "accordion-item",
          {
            key: idx,
            ref: item.id,
            refInFor: true,
            attrs: {
              facets: ["faq"],
              "is-open": _vm.isItemOpen(item.id),
              label: item.label
            },
            on: {
              open: function($event) {
                _vm.onOpen(item.id)
              },
              close: _vm.onClose
            }
          },
          [
            _c(
              "p",
              {
                staticClass: "u-raw-text",
                attrs: { slot: "content" },
                slot: "content"
              },
              [_c("v-runtime-template", { attrs: { template: item.content } })],
              1
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20fcc1cd", { render: render, staticRenderFns: staticRenderFns })
  }
}